var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":_vm.$t('label.label'),"closable":true,"visible":_vm.visible,"maskClosable":false,"width":"350","bodyStyle":{padding: 0}},on:{"close":_vm.onClose}},[_c(_vm.currentComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }